"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.default = exports.HeroFullBleed = void 0;
require("./HeroFullBleed.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actionFormatter = require("../../util/actionFormatter/actionFormatter");
var _getButtonHtml = require("../../util/getButtonHtml/getButtonHtml");
var _getLinkHtml = require("../../util/getLinkHtml/getLinkHtml");
var _renderObject = require("../../util/renderObject/renderObject");
var _GridContainer = _interopRequireDefault(require("../GridContainer/GridContainer"));
var _HeroBody = _interopRequireDefault(require("../HeroBody/HeroBody"));
var _HeroFooter = _interopRequireDefault(require("../HeroFooter/HeroFooter"));
var _HeroHeader = _interopRequireDefault(require("../HeroHeader/HeroHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * HeroFullBleed Component
 *
 * @method
 * @param {HeroFullBleedProps} props
 * @returns HeroFullBleed
 *
 */

const HeroFullBleed = props => {
  const {
    actionGroups,
    backgroundColor = defaultProps.backgroundColor,
    body,
    externalAction,
    externalActionFullyClick,
    externalMedia,
    eyebrow,
    fullyClickableParent,
    footerStyle,
    headline,
    headlineTag = defaultProps.headlineTag,
    image,
    style = defaultProps.style,
    tag,
    textColor = defaultProps.textColor,
    theme = defaultProps.theme
  } = props;
  let formattedActionFullyClick;
  const hasText = body || eyebrow || headline || actionGroups || tag;
  const hasImage = image || externalMedia;
  const isKnockoutLink = textColor === 'content-knockout';
  const paletteOneAction = actionGroups && actionGroups.actions?.length === 1;
  const hasOneAction = fullyClickableParent || paletteOneAction;
  if (paletteOneAction) {
    formattedActionFullyClick = (0, _actionFormatter.actionFormatter)({
      action: actionGroups?.actions[0],
      types: actionGroups?.types,
      hasOneAction: hasOneAction,
      derivedAriaLabel: actionGroups?.actions[0].label,
      fullyClickableParent: paletteOneAction
    }, {
      getButtonMarkup: _getButtonHtml.getButtonHtml,
      getLinkMarkup: _getLinkHtml.getLinkHtml
    });
  }
  const componentClassName = (0, _classnames.default)('pal-c-HeroFullBleed__mainContainer', {
    'pal-c-HeroFullBleed--backgroundColor': backgroundColor
  });

  // dynamically build the background token that takes the theme and background color
  const containerStyle = {
    '--backgroundColor': `var( --pal-colors-${theme}-${backgroundColor} )`
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('pal-c-HeroFullBleed', {
      [`pal-c-HeroFullBleed__${style}`]: style,
      [`pal-c-HeroFullBleed--oneAction`]: hasOneAction
    })
  }, hasOneAction && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formattedActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(formattedActionFullyClick)), externalActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalActionFullyClick))), hasImage && /*#__PURE__*/_react.default.createElement(_HeroHeader.default, {
    externalMedia: externalMedia,
    image: {
      desktopImage: image?.image,
      tabletImage: image?.tabletImage,
      mobileImage: image?.mobileImage,
      ratio: image?.ratio,
      altText: image?.altText,
      loading: image?.loading
    }
  }), hasText && /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    style: containerStyle
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-HeroFullBleed__bodyAndAction"
  }, /*#__PURE__*/_react.default.createElement(_HeroBody.default, {
    tag: tag,
    eyebrow: eyebrow,
    headline: headline,
    headlineTag: headlineTag,
    headlineStyle: "display",
    body: body,
    bodyStyle: "body-xlg",
    textColor: textColor
  }), /*#__PURE__*/_react.default.createElement(_HeroFooter.default, _extends({}, actionGroups, {
    externalAction: externalAction,
    isKnockoutLink: isKnockoutLink,
    style: footerStyle
  }))))));
};

/**
 * Property type definitions
 * @typedef HeroFullBleedProps
 * @type {object}
 * @property {object} actionGroup - Allows passing an object to the actionGroup prop
 * @property {string} backgroundColor - backgroundcolor for hero
 * @property {string} body - body text/description of the hero body
 * @property {object} externalAction - external action object
 * @property {string} eyebrow - smaller text above the headline
 * @property {string} footerStyle - style for footer
 * @property {string} headline - headline text of the hero body
 * @property {string} headlineTag - headline tag of the hero body
 * @property {object} image - desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
 * @property {string} style - sets the style of the card on mobile
 * @property {object} tag - tag component above the eyebrow
 * @property {string} textColor - sets the color of the text
 * @property {string} theme -  sets the theme at the component level
 */
exports.HeroFullBleed = HeroFullBleed;
const propTypes = {
  /**
   * Allows passing an object to the actionGroup prop
   */
  actionGroup: _propTypes.default.object,
  /**
   * Backgroundcolor for hero
   */
  backgroundColor: _propTypes.default.string,
  /**
   * body text/description of the hero body
   */
  body: _propTypes.default.string,
  /**
   * Sets the primary action from an external source that contains business logic
   */
  externalAction: _propTypes.default.object,
  /**
   * Smaller text above the headline
   */
  eyebrow: _propTypes.default.string,
  /**
   * style for footer
   */
  footerStyle: _propTypes.default.string,
  /**
   * headline text of the hero headline
   */
  headline: _propTypes.default.string,
  /**
   * HTML tag for the headline
   */
  headlineTag: _propTypes.default.string,
  /**
   * desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
   */
  image: _propTypes.default.object,
  /**
   * Sets the style of the card on mobile
   */
  style: _propTypes.default.oneOf(['default', 'background-image']),
  /**
   * tag component above the eyebrow
   */
  tag: _propTypes.default.object,
  /**
   * Sets the style of the card on mobile
   */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout']),
  /**
   * Sets the theme
   */
  theme: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag - headlineTag: 'h2' - sets the default for the headline tag
 * @property {string} style - style: 'default' - sets the style of the text
 * @property {string} textColor - textColor: 'content-default'- sets the color of the text to content-default or content-knockout
 * @property {string} theme -  theme: 'default' - sets the theme at the component level
 * @property {string} backgroundColor - sets the background color
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2',
  style: 'default',
  textColor: 'content-default',
  theme: 'default',
  backgroundColor: 'background-default'
};
HeroFullBleed.propTypes = propTypes;
var _default = exports.default = HeroFullBleed;